export default {
    title: "Programa de Fidelidade",
    success_message: "Atualizado com sucesso",
    points_reais_relation: "Relação pontos - reais",
    points_reais_relation_subtitle:
        "Quantos reais o cliente precisa gastar para ganhar 1 ponto?",
    currency: "Reais",
    max_points_per_order: "Máximo de pontos por pedido",
    max_points_per_order_subtitle:
        "Qual é o máximo de pontos que um cliente pode ganhar em um único pedido? Deixe em branco para não ter limite.",
    points: "Pontos",
    warning_order_value: "Valor limite para alerta",
    warning_order_value_subtitle:
        "Se um pedido for gerado com um valor maior que o informado aqui o operador terá que confirmar o pedido antes de salvar.",
    how_to_use_title: "Instruções de uso",
    how_to_use_subtitle:
        "Texto que aparece após o cliente gerar o cupom explicando como resgatar o benefício.",
    call_to_action_title: "Chamada para ação: Cadastro/Avaliação",
    call_to_action_subtitle:
        "Texto enviado via SMS para o cliente ao solicitar que o mesmo complete seu cadastro no Kevi.",
    smart_tags_subtitle:
        "Você pode usar as seguintes tags de substituição inteligente no seu conteúdo:",
    accents_removed: "*Todos os acentos serão removidos.",
    rules_title: "Regras",
    rules_subtitle:
        "Texto que aparece no painel do cliente quando ele clica em regras.",
    save_button: "Salvar",
    page_title: "Kevi | Programa de Fidelidade",
    lifetime_too_short:
        "O tempo de validade do cupom precisa ser de pelo menos um dia.",
    token_copied: "Token copiado com sucesso!",
    journey: {
        title: "Jornada",
        stages: "Etapas",
        add_stage_placeholder: "Adicionar etapa",
        board_prefix: "Prefixo do quadro",
        board_renamed: "Quadro renomeado",
        insert_first_stage: "Inserir primeira etapa",
        insert_first_substage: "Inserir primeira subetapa",
        order_saved: "Ordem salva",
        stage_renamed: "Etapa renomeada",
    },
    plugins: {
        title: "Plugins",
        add_sender: "Adicionar remetente",
        cost_per_message: "Custo por mensagem",
        credits: "Créditos",
        edit_sender: "Editar remetente",
        monthly_value: "Valor mensal",
        none_registered: "Nenhum registrado",
        register_sender: "Registrar remetente",
        save_changes: "Salvar alterações",
        send_test_to: "Enviar teste para",
        sender: "Remetente",
        sender_saved_test_sent: "Remetente salvo e teste enviado",
        soon: "Em breve",
    },
    products: {
        title: "Produtos",
        add_recommendation_optional: "Adicionar recomendação (opcional)",
        add_to_group: "Adicionar ao grupo",
        added_products: "Produtos adicionados",
        ai: "IA",
        ai_placeholder: "Placeholder da IA",
        ai_recommendation_disclaimer: "Aviso de recomendação por IA",
        also_bought: "Também comprou",
        batch_edit: "Edição em lote",
        bought_in_same_order: "Comprado no mesmo pedido",
        bought_together: "Comprado junto",
        brand: "Marca",
        clients_who_bought_also_bought: "Clientes que compraram também compraram",
        cost: "Custo",
        current_price: "Preço atual",
        external_id: "ID externo",
        group: "Grupo",
        group_name: "Nome do grupo",
        group_updated: "Grupo atualizado",
        groups: "Grupos",
        last_10_orders_including_product: "Últimos 10 pedidos incluindo produto",
        last_purchase: "Última compra",
        link_removed: "Link removido",
        manage_groups: "Gerenciar grupos",
        manual: "Manual",
        manual_recommendation_disclaimer: "Aviso de recomendação manual",
        new_group: "Novo grupo",
        no_images: "Sem imagens",
        no_manual_links: "Sem links manuais",
        orders_12m: "Pedidos 12m",
        price_unit: "Unidade de preço",
        product_linked: "Produto vinculado",
        product_not_found: "Produto não encontrado",
        products_updated: "Produtos atualizados",
        purchase_history: "Histórico de compras",
        recommendation_saved: "Recomendação salva",
        remove_from_group: "Remover do grupo",
        repurchase_days: "Dias para recompra",
        revenue_12m: "Receita 12m",
        search_product_to_link: "Buscar produto para vincular",
        something_went_wrong: "Algo deu errado",
        stock: "Estoque",
        use_ai: "Usar IA",
    },
    translations: {
        title: "Traduções",
        description: "Descrição",
        error_saving: "Erro ao salvar",
        items_for: "Itens para",
        key: "Chave",
        locale: "Idioma",
        no_categories_found: "Nenhuma categoria encontrada",
        no_translations_found: "Nenhuma tradução encontrada",
        original_en: "Original (EN)",
        saved: "Salvo",
        saving: "Salvando",
        translated: "Traduzido",
        unable_to_load: "Não foi possível carregar",
        unable_to_load_items: "Não foi possível carregar itens",
    },
    connections: {
        title: "Conexões",
        add_page_title: "Adicionar Conexões",
        add_new: "Adicionar nova conexão",
        my_connections: "Minhas conexões",
        first_connection_title: "Faça sua primeira conexão",
        first_connection_description: "Conecte com as principais plataformas",
        channel_placeholder: "Selecione o canal",
        webhook_read_help: "Webhooks servem para receber status de leitura e recebimento das mensagens.",
        coming_soon: "Em breve",
        request_connection: "Solicite uma conexão",
        request_connection_description: "Se precisa de uma conexão que não está disponível nosso time pode integrar para você.",
        request_message_prefix: "Olá eu gostaria de solicitar uma nova integração de",
        channels: {
            all: "Todas conexões",
            whatsapp: "WhatsApp",
            sms: "SMS",
            rcs: "RCS",
            email: "E-mail",
            whatsapp_cloud: "WhatsApp Oficial",
        },
        table: {
            connector: "Conector",
            name: "Nome",
            monthly_value: "Valor mensal",
            cost_per_message: "Custo por disparo",
            webhook: "Webhook",
            actions: "Ações",
            status: "Status",
            phone_number: "Número de telefone",
        },
        categories: {
            whatsapp_description: "Integre com sua plataforma de WhatsApp favorita ou utilize a infraestrutura da Kevi para não precisar contratar nada extra.",
            sms_description: "Integre com sua plataforma de SMS favorita ou utilize a infraestrutura da Kevi para não precisar contratar nada extra.",
            rcs_description: "Envie RCS com texto, imagem, card, carrossel ou arquivo pela Comtele.",
            email_description: "Integre com sua plataforma de E-mail favorita ou utilize a infraestrutura da Kevi para não precisar contratar nada extra.",
            whatsapp_cloud_description: "Integre com sua plataforma de atendimento via WhatsApp Oficial.",
        },
        common: {
            set_default: "Definir como padrão",
            copied_url: "Copiar url",
            not_supported: "Não suportado",
            active: "Ativo",
            unavailable: "Indisponível",
            not_configured: "Não configurado",
            error: "Erro",
            unknown: "Desconhecido",
            loading: "Carregando...",
            connected: "Conectado",
            disconnected: "Desconectado",
            corrupted_instance: "Instância corrompida.",
            corrupted_instance_tooltip: "A instância do WhatsApp está corrompida e precisa ser substituída ou reconfigurada.",
            webhook_pending_tooltip: "O webhook ainda não foi configurado. Configure-o para saber se as mensagens foram lidas e recebidas.",
            webhook_error_tooltip: "Houve um erro na configuração do webhook. Verifique as configurações.",
            webhook_unknown_tooltip: "O status do webhook não pode ser determinado via integração, verifique no seu provedor.",
            webhook_unavailable_tooltip: "Essa integração não suporta webhooks.",
            sender_no_webhooks: "Este sender não suporta webhooks",
            click_view_webhooks: "Clique para ver os eventos de webhook",
            last_event_received: "Último evento recebido em {$0}",
            credits_suffix: "créditos",
            copied_success: "URL copiada com sucesso!",
            copy_error: "Erro ao copiar URL",
            not_available: "N/A",
        },
        sender_form: {
            details_tab: "Detalhes",
            settings_tab: "Configuração",
            adding_connection: "Adicionando Conexão",
            connection_cost: "Custo da Conexão",
            monthly_subscription: "Assinatura mensal",
            connection_valid_per_phone: "Conexão válida por número de telefone",
            credit_cost: "Custo de créditos",
            per_message_sent: "Por mensagem enviada",
            what_you_need_to_know: "O que você precisa saber?",
            edit: "Editar",
            close: "Fechar",
            install_connection: "Instalar conexão",
            edit_settings: "Editar configurações",
            configure_how: "Como configurar",
            edit_instructions: "Editar instruções",
            edit_sender_description: "Editar descrição do sender",
            edit_configuration_instructions: "Editar instruções de configuração",
            format_help: "Use a barra de formatação para estilizar o texto.",
            description_placeholder: "Digite a descrição do sender...",
            instructions_placeholder: "Digite as instruções de configuração...",
            cancel: "Cancelar",
            save: "Salvar",
            default_body: "<p>Informações sobre esta conexão serão exibidas aqui.</p>",
            default_instructions: "<p>Se precisar de ajuda, entre em contato com o suporte da Kevi pelo Whatsapp</p>",
        },
        steps: {
            configure: "Configurar",
            scan: "Escanear",
            test: "Testar",
            finish: "Concluir",
            title: "Título",
            cancel: "Cancelar",
            next: "Próximo",
            saving: "Salvando...",
            back: "Voltar",
            send_test: "Enviar teste",
            sending_test: "Enviando teste...",
            enter_email: "Digite um e-mail",
            example_email: "exemplo@email.com",
            enter_mobile_number: "Digite um número de celular",
            enter_mobile_short: "Digite um celular",
            select_template: "Selecione o template",
            no_template_available: "Nenhum template disponível.",
            header: "Topo",
            body: "Corpo",
            button: "Botão",
            image_url: "URL da imagem",
            header_media_url_video: "URL do vídeo",
            header_media_url_document: "URL do documento",
            header_media_url_gif: "URL do GIF",
            document_filename: "Nome do arquivo (opcional)",
            document_filename_placeholder: "ex.: nota-fiscal.pdf",
            location_header: "Localização (cabeçalho)",
            location_latitude: "Latitude",
            location_longitude: "Longitude",
            location_name: "Nome do local",
            location_address: "Endereço",
            approved: "Aprovado",
            rejected: "Rejeitado",
            pending: "Pendente",
            test_completed_success: "Teste concluído com sucesso",
            did_not_receive_test: "não recebi o teste.",
            done: "Concluir",
            channel_ready_default: "Sua conexão está ativa e pronta para uso.",
            channel_ready_whatsapp: "Sua conexão com o WhatsApp está ativa e pronta para uso.",
            channel_ready_sms: "Sua conexão SMS está ativa e pronta para uso.",
            channel_ready_rcs: "Sua conexão RCS está ativa e pronta para uso.",
            channel_ready_email: "Sua conexão de e-mail está ativa e pronta para uso.",
            channel_ready_whatsapp_cloud: "Sua conexão WhatsApp Cloud está ativa e pronta para uso.",
            connection_check_error: "Erro ao verificar a conexão.",
            verify_settings_or_support: "Verifique as configurações ou fale com o suporte.",
            scan_qr_instruction: "Acesse seu WhatsApp e escaneie o QR code",
            qr_code_error: "Erro ao gerar o QR Code.",
            whatsapp_connected: "Whatsapp Conectado",
            generate_qr_again: "Gerar QR Code novamente",
            try_again: "Tentar novamente",
            expand_qr: "Expandir QR Code",
            expanded_qr_title: "Escanear QR Code",
            keep_phone_close: "Aponte a câmera do seu celular para a tela para conectar.",
            close: "Fechar",
        },
        webhooks: {
            title: "Webhooks",
            back: "Voltar",
            status_24h_summary: "Status calculado pelos eventos recebidos nas últimas 24h.",
            last_event: "Último evento: {$0}",
            description_line_1: "<strong>Webhooks</strong> são notificações enviadas pelo seu provedor (Mailgun, SMS, WhatsApp Cloud, etc.) para a Kevi quando ocorre um evento (entrega, leitura, falha, resposta).",
            description_line_2: "Eles são importantes para a Kevi conseguir atualizar status, métricas e automações de forma confiável.",
            managed_by_kevi: "Este disparador é gerenciado pela Kevi então a URL do webhook é configurada automaticamente.",
            webhook_url: "URL do webhook",
            copy: "Copiar",
            received_events: "Eventos recebidos",
            no_events: "Nenhum evento de webhook foi recebido ainda para este sender.",
            received_at: "Recebido em",
            event: "Evento",
            contact: "Contato",
            client: "Cliente",
            provider_id: "Provider ID",
            status: "Status",
            error: "Erro",
            data: "Dados",
            processed: "Processado",
            failed: "Falhou",
            view_data: "Ver dados",
            details_title: "Dados do webhook",
            summary: "Resumo",
            received: "Recebido",
            provider_event: "Provider event",
            payload_json: "Payload (JSON)",
            headers_json: "Headers (JSON)",
            close: "Fechar",
        },
        notifications: {
            load_error: "Erro ao carregar conexões: {$0}",
            execute_command_error: "Erro ao executar comando: {$0}",
            set_default_success: "Conexão definida como padrão com sucesso",
            set_default_error: "Erro ao definir conexão como padrão: {$0}",
            sender_id_not_found: "Erro: ID do sender não encontrado. Salve a configuração primeiro.",
            test_sent_success: "Teste enviado com sucesso",
            config_saved_success: "Configuração salva com sucesso",
            description_saved_success: "Descrição salva com sucesso",
            description_save_error: "Erro ao salvar descrição: {$0}",
            instructions_saved_success: "Instruções salvas com sucesso",
            instructions_save_error: "Erro ao salvar instruções: {$0}",
            unknown_error: "Erro desconhecido",
            command_executed_success: "Comando executado com sucesso",
            test_send_error: "Erro ao enviar teste: {$0}",
            price_updated_success: "Valor mensal atualizado com sucesso",
            price_update_error: "Erro ao atualizar valor mensal",
            credits_cost_updated_success: "Custo por disparo atualizado com sucesso",
            credits_cost_update_error: "Erro ao atualizar custo por disparo",
            sender_default_has_others: "Disparador padrão de {$0}. Defina outro padrão antes de excluir.",
            sender_in_use_automations: "Em uso na(s) automação(ões): {$1}. Altere ou desative antes de excluir.",
            sender_in_use_branches: "Vinculado à(s) filial(is): {$0}. Desvincule antes de excluir.",
            sender_in_use_users: "Vinculado ao(s) vendedor(es): {$0}. Desvincule antes de excluir.",
            sender_not_found: "Disparador não encontrado ou inativo.",
        },
    },
};
